import axios from "axios";
import env from "../env";

const api_url = env.API_URL;

export const updateAttendance = async (token: string, userId:any, subjectId:string, date:string, isAttend:boolean) => {
    try {
        const response = await axios.put(`${api_url}attendance/${userId}?subjectId=${subjectId}&date=${date}&isAttend=${isAttend}`, {
        }, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getSubjectId = async (token: string, programme:string, stream:string, subject:string) => {
    try {
        const response = await axios.get(`${api_url}attendance/subject?programme=${programme}&stream=${stream}&subject=${subject}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getAttendanceRecords = async (token: string, userId:any) => {
    try {
        const response = await axios.get(`${api_url}attendance/user/${userId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}

export const getAttendanceListBySubject = async (token: string, subjectId:string) => {
    try {
        const response = await axios.get(`${api_url}attendance/current-session?subjectId=${subjectId}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
}